import React from "react";
import { PersianDate } from "../../../helpers/utility";

export const ticketStatusDict = {
  new: "جدید",
  processing: "در حال بررسی",
  open: "پاسخ داده شده",
  closed: "تکمیل شده",
  rejected: "رد شده",
  manager_responded: "پاسخ ادمین",
  user_responded: "پاسخ کاربر"
};

export const statusColorDict = {
  new: "#0f3",
  processing: "#fe3",
  open: "#33f",
  closed: "#aaa",
  rejected: "#f33",
  manager_responded: "#00c76b",
  user_responded: "#00b6fd"
};

const circleColor = {
  width: "15px",
  height: "15px",
  borderRadius: "50%",
  display: "inline-block",
  verticalAlign: "middle",
  margin: "0 5px"
};

export const isTicketNew = ticket_status => ticket_status === "new";

export const statusRendererWithColor = status => {
  return statusColorDict.hasOwnProperty(status) ? (
    <div>
      <span
        style={{ ...circleColor, backgroundColor: statusColorDict[status] }}
      ></span>
      {statusRenderer(status)}
    </div>
  ) : (
    statusRenderer(status)
  );
};

export const statusRenderer = status => {
  return ticketStatusDict.hasOwnProperty(status)
    ? ticketStatusDict[status]
    : "-";
};

export const typeRenderer = type => {
  return (type && type.title) || "-";
};

export const dateRenderer = datetime => <PersianDate>{datetime}</PersianDate>;

export const adminInfoRenderer = info => {
  return info.role !== "manager" ? null : (
    <div>
      <span>------------</span>
      <p>
        سمت: {info.title ? info.title : " - "}
        &nbsp;&nbsp; شماره تماس: {info.phone_number ? info.phone_number : " - "}
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/Support/helpers.js